import { useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import { getPopupLabel, getPopupVisualSeverity } from './popupGraphics'
import FullPagePopupLayout from './FullPagePopupLayout'

const MessagePopup = () => {
  const { isOpen, onClose, type, data } = useModal()
  const navigate = useNavigate()

  const isModalOpen = isOpen && type === 'openPopup'
  const severity = getPopupVisualSeverity(data?.severity || 'notice')
  const label = getPopupLabel(data?.severity || severity)
  const showCloseButton = !data?.hideCloseButton
  const showForwardButton = data?.showExploreButton !== false && !data?.hideForwardButton
  const actionCount = Number(showCloseButton) + Number(showForwardButton)
  const closeButtonText = data?.secondaryActionText || data?.closeButtonText || 'Close'
  const forwardButtonText = data?.primaryActionText || data?.exploreButtonText || 'Explore Funds'

  const handleClose = () => {
    onClose()
    if (data?.redirectBackTo === null) return
    navigate(data?.redirectBackTo || 'dashboard/mutual-funds', {
      state: data?.redirectState,
    })
  }

  const handleForward = () => {
    onClose()
    if (typeof data?.onPrimaryAction === 'function') {
      data.onPrimaryAction()
      return
    }
    if (data?.forwardTo === null) return
    navigate(data?.forwardTo || 'dashboard/mutual-funds', {
      state: data?.forwardState,
    })
  }

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity || severity}
      title={data?.title || label}
      message={data?.message}
      actions={
        <>
          {showCloseButton && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={handleClose}
            >
              {closeButtonText}
            </button>
          )}
          {showForwardButton && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleForward}
            >
              {forwardButtonText}
            </button>
          )}
        </>
      }
      actionsClassName={actionCount < 2 ? 'fabits-global-popup-actions-single' : undefined}
      disableDismiss={data?.disableDismiss}
    />
  )
}

export default MessagePopup
